import { FunctionComponent, ReactElement, useEffect } from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';

interface ScrollToProps {
  children?: ReactElement;
  bottom?: boolean;
}

const ScrollToTop: FunctionComponent<ScrollToProps & RouteComponentProps> = ({
  children,
  location: { pathname },
}) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return children || null;
};

export default withRouter(ScrollToTop);
